import { render, staticRenderFns } from "./ServiceForm.vue?vue&type=template&id=c5a699a0&"
import script from "./ServiceForm.vue?vue&type=script&lang=js&"
export * from "./ServiceForm.vue?vue&type=script&lang=js&"
import style0 from "./ServiceForm.vue?vue&type=style&index=0&id=c5a699a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports